<template>
  <lsSearchForm
    ref="lsSearchForm"
    @search="handleSearch"
    :initExpand="false"
    :formList="formList"
    :searchContentFold="false"
  >
    <!--加工组织-->
    <global-select
      slot="organizationCode"
      selectType="selectAssemble"
      requestApi="/system/user/inventOrgAll"
      :selectItem="{ value: 'realValue', label: 'label' }"
      :dropdown-match-select-width="false"
      v-decorator="['organizationCode', { initialValue: this.organizationCodeOrigin || '' }]"
      :assembleLabel="true"
      :disabled="isDisableOrganization"
    />
  </lsSearchForm>
</template>

<script>
import isNil from 'lodash/isNil';
import { mapState } from 'vuex';
import { STATUS_CODE } from '../common.js';

export default {
  name: 'SearchForm',
  components: {},
  data() {
    return {
      routingList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'; // 林氏产业园库存组织可
    },
    formList() {
      const result = [
        {
          label: "加工组织",
          type: "organizationCode"
        },
        {
          label: 'SPU',
          type: "input",
          decorator: ["itemName"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "规格",
          type: "input",
          decorator: ["specification"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "成品SKU",
          type: "input",
          decorator: ["itemCode"],
          attrs: {
            placeholder: "请输入"
          }
        },
        {
          label: "是否生效",
          type: "select",
          decorator: ["enable", { initialValue: STATUS_CODE.enabled.value }],
          options: Object.values(STATUS_CODE).map(item => ({ key: item.value, value: item.label })),
          attrs: {
            placeholder: "请选择"
          }
        }
      ]
      return result;
    }
  },
  methods: {
    handleSearch(values) {
      for(const filed in values) {
        if(isNil(values[filed]) || values[filed] === '') {
          delete values[filed]
        }
      }
      delete values.searchFormLabel
      this.$emit("search", values);
    },
    handleFormSearch() {
      this.$refs.lsSearchForm.handleSearch();
    }
  }
}
</script>

<style lang="less" scoped></style>
